export class FacebookFeed {
  private el: HTMLElement;
  private language: string;

  private static readonly LANGUAGE_MAP: Record<string, string> = {
    de: "de_DE",
    en: "en_GB",
    fr: "fr_FR",
    it: "it_IT",
    es: "es_ES",
    zh_cn: "zh_CN",
    sv: "sv_SE",
    ja: "ja_JP",
    ko: "ko_KR",
    nl: "nl_NL",
    pt: "pt_BR",
    fi: "fi_FI",
    da: "da_DK",
    no: "nn_NO",
  };

  constructor(el: HTMLElement) {
    this.el = el;
    const languageData = this.el.dataset.language || "";
    this.language =
      FacebookFeed.LANGUAGE_MAP[languageData || "en"] || "en_GB";
  }

  init(): void {
    this.initFacebookFeed();
  }

  private initFacebookFeed(): void {
    if (document.getElementById("facebook-jssdk")) return;

    const js = document.createElement("script");
    js.id = "facebook-jssdk";
    js.src = `//connect.facebook.net/${this.language}/sdk.js#xfbml=1&version=v2.8`;

    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(js, firstScript);
    } else {
      document.head.appendChild(js);
    }
  }

  destroy(): void {
    // No event listeners to clean up — script injection is one-time
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="facebook-feed"]')
      .forEach((el) => {
        new FacebookFeed(el).init();
      });
  }
}
